<template>
  <div id="app">
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no" />
    </head>

    <router-view></router-view>
  </div>
</template>

<script>
import VConsole from 'vconsole';
export default {
  name: 'App',
  mounted() {
    if (process.env.NODE_ENV !== 'production') {
      const vConsole = new VConsole();
    }
  },
};
</script>

<style lang="scss">
@import './assets/sass/app.scss';
@import './assets/sass/wx.scss';
</style>
